module.exports = __webpack_public_path__ + "performance-bad.48c83a77d1134640c1460eb6081279bc.hashedasset.png";